import { useMutation } from 'react-query'

import { api } from '../../../api'
import { type ClientPersistence } from '../../../../types/persistence/client-persistence'

const createClient = async (newClient: ClientPersistence) => {
  const response = await api.post('/clients', newClient)
  return response.data
}

export const useClientCreateMutation = () => {
  return useMutation('remove-client', {
    mutationFn: (newClient: ClientPersistence) => {
      return createClient(newClient)
    },
  })
}
